<template>
    <div class="page">
        <div class="page-content">
            <div class="bk-page">
                <img class="block-img" src="../assets/images/cards.png">
                <div class="jx-list">
                    <div class="title"><span>精选推荐</span></div>
                    <ul class="clearfix">
                        <li class="pa1" @click="$router.push('/card/list')">
                            <p class="p1">新手办卡</p>
                            <p class="p2">办好卡 送好礼</p>
                        </li>
                        <li class="pa2" @click="$router.push('/card/list')">
                            <p class="p1">大额度</p>
                            <p class="p2">额度任性带你飞</p>
                        </li>
                        <li class="pa3" @click="$router.push('/card/list')">
                            <p class="p1">审批快</p>
                            <p class="p2">至快当天下卡</p>
                        </li>
                        <li class="pa4" @click="$router.push('/card/list')">
                            <p class="p1">易下卡</p>
                            <p class="p2">门槛低 易通过</p>
                        </li>
                    </ul>
                </div>
                <p class="block-title">推荐银行</p>
                <ul class="bank-list clearfix mb15">
                    <li v-for="item in bankList" @click="$router.push('/bank/card')">
                        <div class="b-b">
                            <i class="icon"></i>
                            <h4>{{item['bank_name']}}</h4>
                            <p class="p1">{{item['bank_desc']}}</p>
                            <p class="p2">奖金 ¥{{item['bank_jj']}}</p>
                        </div>
                    </li>
                </ul>
                <ul class="remen-card">
                    <li class="title"><span>热门卡片</span></li>
                    <li class="flex item t-line" v-for="item in cardList" @click="$router.push('/card/detail')">
                        <div class="l-bbb"><img src="../assets/images/cd-card.png"/></div>
                        <div>
                            <h4>{{item.name}}</h4>
                            <p class="p1">{{item.desc}}</p>
                            <p class="tags">
                                <a v-for="tag in item.tags">{{tag}}</a>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            bankList: [{
                bank_name: '交通银行',
                bank_desc: '最红星期五',
                bank_jj: '110.00'
            }, {
                bank_name: '浦发银行',
                bank_desc: '小浦年中庆，积分嘉年华',
                bank_jj: '150.00'
            }, {
                bank_name: '上海银行',
                bank_desc: '周六美食半价',
                bank_jj: '90.00'
            }, {
                bank_name: '民生银行',
                bank_desc: '最快当天批卡',
                bank_jj: '70.00'
            }, {
                bank_name: '兴业银行',
                bank_desc: '移动兴支付，5折享不停',
                bank_jj: '80.00'
            }, {
                bank_name: '中信银行',
                bank_desc: '享多倍积分',
                bank_jj: '50.00'
            }, {
                bank_name: '光大银行',
                bank_desc: '10元享电影',
                bank_jj: '120.00'
            }, {
                bank_name: '招商银行',
                bank_desc: '周三五折美食',
                bank_jj: '40.00'
            }, {
                bank_name: '广发银行',
                bank_desc: '新户刷卡满额赏',
                bank_jj: '110.00'
            }, {
                bank_name: '华夏银行',
                bank_desc: '专享京东立减优惠',
                bank_jj: '50.00'
            }],
            cardList: [{
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }]
        }
    }
}
</script>
